import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-work-permit',
  templateUrl: './work-permit.component.html',
  styleUrls: ['./work-permit.component.css']
})
export class WorkPermitComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }
  public back(){
    this.location.back();
  }
}
